__webpack_require__.p = "/investing-for-life/";